import { render, staticRenderFns } from "./WatchTable.vue?vue&type=template&id=2511e15c"
import script from "./WatchTable.vue?vue&type=script&lang=js"
export * from "./WatchTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports